(function () {
  var modal, content, closeBtn, lastFocus;

  // Shopify prefixes every path under a localised market, so the literals
  // these used to hold 404 on any store that is not the primary market.
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CART_ADD = (window.routes && window.routes.cart_add_url) || ROOT + 'cart/add';
  var CART_URL = (window.routes && window.routes.cart_url) || ROOT + 'cart';

  function ensureModal() {
    if (modal) return modal;
    modal = document.createElement('div');
    modal.className = 'qv-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="qv-modal__overlay" data-qv-close></div>' +
      '<div class="qv-modal__dialog" role="dialog" aria-modal="true" aria-label="Quick view">' +
        '<button type="button" class="qv-modal__close" aria-label="Close" data-qv-close>&times;</button>' +
        '<div class="qv-modal__body"><div class="qv-modal__loading">Loading…</div></div>' +
      '</div>';
    document.body.appendChild(modal);
    content = modal.querySelector('.qv-modal__body');
    modal.addEventListener('click', function (e) {
      if (e.target.hasAttribute('data-qv-close')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
    return modal;
  }

  function open() {
    ensureModal();
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // The dialog opened with focus still behind it, so keyboard and screen
    // reader users carried on tabbing through the page underneath.
    var first = modal.querySelector('.qv-modal__close');
    if (first) first.focus();
  }

  // Adding from the quick view opens the cart drawer, which sits below this
  // dialog and cannot be reached or even seen behind it. The dialog has done its
  // job by then, so it steps out of the way and lets the drawer through.
  var cartSub = null;
  function watchCart() {
    if (cartSub) return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    cartSub = subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      if (modal && modal.classList.contains('is-open')) close();
    });
  }

  function close() {
    if (cartSub) { cartSub(); cartSub = null; }
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    content.innerHTML = '<div class="qv-modal__loading">Loading…</div>';
    if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    lastFocus = null;
  }

  // Keep Tab inside the dialog while it is open.
  function trap(e) {
    if (e.key !== 'Tab' || !modal || !modal.classList.contains('is-open')) return;
    var items = modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }
  document.addEventListener('keydown', trap);

  // The quick view shows the product page's own section rather than a copy of
  // it. A copy drifts: every setting changed on the product page has to be
  // changed again here, and the two quietly stop matching. Rendering the real
  // section means the title, the price, the variant pickers, the buy button and
  // the payment icons are the same ones, with the same settings, always.
  //
  // Shopify only applies the template's settings when the section is asked for
  // by its full id, which carries the template in it and is not knowable from
  // Liquid on a collection page. It is read once from a product page and kept
  // for the rest of the visit.
  var SECTION_KEY = 'kisa-qv-section-id';

  function sectionId(handle) {
    var known = null;
    try { known = sessionStorage.getItem(SECTION_KEY); } catch (e) {}
    if (known) return Promise.resolve(known);
    return fetch(ROOT + 'products/' + handle, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = html.match(/id="shopify-section-(template--[^"]*__main)"/);
        var id = m ? m[1] : null;
        if (id) { try { sessionStorage.setItem(SECTION_KEY, id); } catch (e) {} }
        return id;
      })
      .catch(function () { return null; });
  }

  function load(handle) {
    open();
    sectionId(handle).then(function (id) {
      // Without the id there is nothing to render from, so the shopper is
      // sent to the product page rather than shown an empty dialog.
      if (!id) {
        content.innerHTML = '<div class="qv-modal__loading"><a href="' + ROOT + 'products/' + handle + '">Open product page</a></div>';
        return;
      }
      return render(ROOT + 'products/' + handle + '?section_id=' + encodeURIComponent(id), handle);
    });
  }

  function render(url, handle) {
    return fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        content.innerHTML = html;
        // Inserted markup does not run its own scripts, so they are rebuilt.
        //
        // Only the ones that are actually code. The section also carries a
        // variant list and structured data as application/json, and rebuilding
        // those as plain script tags made the browser try to run JSON as
        // JavaScript, which threw on the first colon it met.
        content.querySelectorAll('script').forEach(function (oldScript) {
          var type = (oldScript.getAttribute('type') || '').toLowerCase();
          var isCode = !type || type === 'text/javascript' || type === 'module' ||
                       type === 'application/javascript';
          if (!isCode) return;
          var s = document.createElement('script');
          if (type) s.type = type;
          if (oldScript.src) s.src = oldScript.src;
          else s.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(s, oldScript);
        });
        watchCart();
        // Choosing a variant rewrites the address bar to the product's URL. On a
        // product page that is right. Here the shopper is still on the
        // collection, so the bar would name a page they are not on and a refresh
        // would take them somewhere they did not ask to go. The section already
        // has a switch for it.
        content.querySelectorAll('product-info, variant-selects, variant-radios').forEach(function (el) {
          el.dataset.updateUrl = 'false';
        });
      })
      .catch(function () {
        content.innerHTML = '<div class="qv-modal__loading">Could not load product. <a href="' + ROOT + 'products/' + handle + '">Open product page</a></div>';
      });
  }

  window.kisaQuickView = load;

  // One delegated listener. The previous version bound each button and kept a
  // MutationObserver on document.body running querySelectorAll for the lifetime
  // of the page to catch new ones.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-quick-view]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-quick-view');
    if (handle) { lastFocus = btn; load(handle); }
  });

})();
